import { Enums } from '../common/enums'
import { DataType } from '../../helpers/common-helper'
import { Utils } from '../util/utils'
import { DataProvider } from '../../helpers/data-provider'
import { Dictionary } from '../../helpers/dictionary'
import { CommonHelper } from '../../helpers/common-helper'

import { OpDescr } from '../core/op-descr'
import { OpFile } from '../core/op-file'
import { OpDashboardControl } from './op-dashboard-control'
import { OpDashboardGroup } from './op-dashboard-group'
import { OpEnumObject } from './op-enum-object'
import { OpSchema } from './op-schema'

export class OpSchemaControl extends OpDashboardControl {
    //Properties
    public schemas: OpSchema[]
    //Properties end

    //NavigationProperties
    //NavigationProperties end

    constructor(opObj: any) {
        super(opObj)
        if (opObj) {
            if (opObj.Schemas)
                this.schemas = opObj.Schemas.map(data => new OpSchema(data))
        }
        if (!this.schemas)
            this.schemas = []
    }
}